"use client";
import { signIn } from "next-auth/react";
import { useState } from "react";
import { useRouter } from "next/navigation";

export default function Login() {
  const [username, setU] = useState("");
  const [password, setP] = useState("");
  const [error, setError] = useState<string | null>(null);
  const router = useRouter();

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    const res = await signIn("credentials", { username, password, redirect: false });
    if ((res as any)?.error) {
      setError("Login fehlgeschlagen");
      return;
    }
    setError(null);
    router.replace("/");
  }

  return (
    <main className="p-6 max-w-md mx-auto">
      <h1 className="text-xl mb-4">Anmelden</h1>
      <form onSubmit={onSubmit} className="space-y-3">
        <input className="border p-2 w-full" placeholder="Benutzername" value={username} onChange={e=>setU(e.target.value)} />
        <input className="border p-2 w-full" type="password" placeholder="Passwort" value={password} onChange={e=>setP(e.target.value)} />
        {error && <div className="text-red-600">{error}</div>}
        <button className="bg-black text-white px-4 py-2">Login</button>
      </form>
      <p className="mt-4 text-sm text-gray-600">Konten werden durch Administratoren erstellt.</p>
    </main>
  );
}
